import { I18nThemed } from 'interfaces/mixins';
import { w, v } from '@dojo/framework/core/vdom';
import { DNode } from '@dojo/framework/core/interfaces';
import { Store } from '@dojo/framework/stores/Store';
import { storeInject } from '@dojo/framework/stores/StoreInjector';

import { SiteMeta, TopicRoots, TopicAttrs } from 'lcc-state/interfaces';
import { TopicHead } from 'book-widgets';

export interface LPTopicRootProperties {
	classes?: string[];
	name?: string;
	topicroot?: string;
	topics: TopicRoots;
}

function getProperties(store: Store<SiteMeta>) {
	const { get, path } = store;
	return {
		topics: get(path('topics'))
	} as LPTopicRootProperties;
}

@storeInject({
	name: 'lcc-state',
	paths: [['topics']],
	getProperties
})
export class LPTopicRoot extends I18nThemed<LPTopicRootProperties> {
	protected render(): DNode {
		const { classes = [], name = '', topicroot = '', topics } = this.properties;

		const gotData = () => {
			const topicdef = topics[topicroot];
			const { attributes = {} as TopicAttrs, children = [] } = topicdef.topichead;
			return w(TopicHead, { key: name, topic: { attributes, children } });
		};

		return topics ? gotData() : v('div', { classes, key: name, xqa: `lptopicroot ${name}` });
	}
}

export default LPTopicRoot;
